import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Service Worker (PWA) - actif en production ET preview, mais pas en dev local
// pour preserver le hot-reload. Les builds CRA en dev peuvent etre detectes via
// l'absence du domaine emergentagent.com / real-ease.fr.
if ("serviceWorker" in navigator) {
  const isLocal = ["localhost", "127.0.0.1"].includes(window.location.hostname);
  if (!isLocal) {
    // Un nouveau SW qui prend le controle = nouvelle version deployee -> on recharge
    // (sauf premiere installation, pour ne pas surprendre le premier chargement)
    const hadController = !!navigator.serviceWorker.controller;
    let refreshed = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (!hadController || refreshed) return;
      refreshed = true;
      window.location.reload();
    });
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/sw.js", { updateViaCache: "none" })
        .then((reg) => {
          reg.update().catch(() => {});
          setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
          console.log("[PWA] SW enregistre :", reg.scope);
        })
        .catch((err) => console.warn("[PWA] SW echec :", err));
    });
  }
}
